import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Materiel } from 'src/app/model/materiel/materiel.model';
import { WebConfigurationService } from '../http/common/web-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class MaterielService extends WebConfigurationService {

  constructor( protected http: HttpClient ) { 
    super( http );
  }
  /**
   * Get one materiel
   * @param id  the id of the materiel
   * @returns an Observable
   */
   public getMateriel( id : string ): Observable<Materiel> {
    return  this.authGetObs<Materiel>( this.getMaterielUrl( id ) );
  }
}
